import * as React from 'react';

import CatalogItem               from '../../../components/catalog/CatalogItem';
import CloseIcon                 from '../../../components/icons/CloseIcon';
import { Price }                 from '../../../new-components';
import { useDeleteCompareModal } from '../../../providers/deleteCompareModal';

const CompareTableItem = function(props) {
  const {
          offer,
          isInterior,
          setCurrentOffer,
          screenWidth,
        } = props;

  const { showModal } = useDeleteCompareModal();

  const offerData = React.useMemo(() => {
    return Object.values(offer)[0].common;
  }, [offer]);

  return (
    <th>
      <div className={'table_item_wrapper'}>
        <div className={'table_item'}>
        <span
          className={'close'}
          onClick={() => {
            showModal(true);
            setCurrentOffer(offerData);
          }}
        >
          <CloseIcon />
        </span>
          <CatalogItem
            hidePrices
            isButtonsNextToSubtitle={screenWidth < 767}
            isInterior={isInterior}
            offers={offer}
            shareButtonVisible
          />
          {!isInterior && (
            <Price
              discountPrice={offerData.discountPrice}
              isMarker={offerData.isMarker}
              isSpecMarker={offerData.isSpecMarker}
              isExpressMarker={offerData.isExpressMarker}
              price={offerData.price}
              showDiscountPrice={offerData.showDiscountPrice}
            />
          )}
        </div>
      </div>
    </th>
  );
};

export default CompareTableItem;